import { BaseModule } from "./base.module";

export class NotificationModule {
    initialize() {
        this.notificationElements = document.querySelectorAll('.notification');

        this.notificationElements.forEach((element) => new Notification(element));
    }
}

class Notification extends BaseModule {
    constructor(notificationElement) {
        super();
        this.notificationElement = notificationElement;

        if (!this.closeButton) {
            return;
        }

        this.initialize();
    }

    get closeButton() {
        return this.notificationElement.querySelector('.notification__close');
    }

    initialize() {
        if (sessionStorage.getItem('hide-top-notification')) {
            return;
        }

        this.notificationElement.classList.remove('notification--closed');

        this.closeButton.addEventListener('click', this.close.bind(this));
    }

    close() {
        sessionStorage.setItem('hide-top-notification', true);
        this.triggerEventOnElement('notification-closed', document.documentElement);
        this.notificationElement.classList.add('notification--closed');
    }
}